import {
    Box,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import icon from "/src/assets/FightLessWinMore_Cover-150px.png"
import lightIcon from '/src/assets/FightLessWinMore_Cover-150px.png'
import { useAppStateContext } from "../../state/AppContextProvider";
import { useContext } from "react";
import { AccessContext } from "../../state/AccessProvider";

// Sample data for suggestion cards
const suggestionCards = [
    {
        id: 1,
        text: "I'd like help with an upcoming negotiation.",
    }
];

interface MuiWelcomeProps {
    onSuggestionClick?: (text: string) => void;
}
export const MuiWelcome = ({ onSuggestionClick }: MuiWelcomeProps): JSX.Element => {
    const appStateContext = useAppStateContext();
    const accessContext = useContext(AccessContext);
    const isSalesforceUser = accessContext.extraLoginInfo?.type === "salesforceUser";

    return (
        <>
            {/* Welcome Section */}
            <Stack spacing={8} alignItems="center" width="100%" flex={3} justifyContent={'center'} sx={{ mt: 8, ml: { xs: 0, sm: 'calc(var(--side-bar-width) / -2)' } }}>
                <Stack spacing={4} alignItems="center" maxWidth="300px">
                    <Box
                        component="img"
                        src={appStateContext.state.themeMode === 'light' ? icon : lightIcon}
                        alt="Fight Less Win More"
                        sx={{
                            width: 70,
                            height: 'auto',
                        }}
                    />

                    <Typography variant="h3" align="center">
                    Fight Less, Win More. Negotiation Prep
                    </Typography>

                    <Typography
                        variant="caption"
                        align="center"
                        sx={{
                            fontSize: "12px",
                            color: "text.disabled",
                            fontFamily: "'Poppins', Helvetica",
                        }}
                    >
                        Negotiation Maximizer
                    </Typography>
                </Stack>

                {/* Suggestion Cards */}
                {!isSalesforceUser && (
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Stack
                        spacing={2}
                        sx={{
                            width: "100%",
                            maxWidth: { xs: "100%", sm: 400 }, // limit width on desktop
                            mx: "auto",
                        }}
                    >
                        <Stack direction="row" spacing={2} width="100%" justifyContent="center">
                            {suggestionCards.slice(0, 2).map((card) => (
                                <Paper
                                    key={card.id}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        background: 'background.paper',
                                        borderRadius: '40px',
                                        boxShadow: 'none',
                                        height: '25px',
                                        minWidth: '0',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        px: 0,
                                        py: 0,
                                        '&:hover': {
                                            background: 'linear-gradient(90deg, #b8091a 0%, #e50c20 100%) !important',
                                            color: '#fff',
                                        },
                                    }}
                                    onClick={() => onSuggestionClick?.(card.text)}
                                >
                                    <Box
                                        sx={{
                                            background: 'linear-gradient(90deg, #e50c20 0%, #b8091a 100%)',
                                            width: '2%',
                                            minWidth: '20px',
                                            height: '100%',
                                            borderRadius: '40px 0 0 40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    />
                                    <Typography
                                        component="p"
                                        sx={{
                                            fontSize: '.85rem',
                                            fontWeight: 400,
                                            pl: 2,
                                            pr: 4,
                                            py: 1.5,
                                            textAlign: 'left',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {card.text}
                                    </Typography>
                                </Paper>
                            ))}
                        </Stack>

                        <Stack direction="row" spacing={2} width="100%" >
                            {suggestionCards.slice(2, 4).map((card) => (
                                <Paper
                                    key={card.id}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        background: '#fff',
                                        borderRadius: '40px',
                                        boxShadow: 'none',
                                        height: '25px',
                                        minWidth: '0',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        px: 0,
                                        py: 0,
                                        '&:hover': {
                                            background: 'linear-gradient(90deg, #b8091a 0%, #e50c20 100%) !important',
                                        },
                                    }}
                                    onClick={() => onSuggestionClick?.(card.text)}
                                >
                                    <Box
                                        sx={{
                                            background: 'linear-gradient(90deg, #e50c20 0%, #b8091a 100%)',
                                            width: '2%',
                                            minWidth: '20px',
                                            height: '100%',
                                            borderRadius: '40px 0 0 40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    />
                                    <Typography
                                        component="p"
                                        sx={{
                                            fontSize: '.85rem',
                                            fontWeight: 400,
                                            pl: 2,
                                            pr: 4,
                                            py: 1.5,
                                            textAlign: 'left',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        {card.text}
                                    </Typography>
                                </Paper>
                            ))}
                        </Stack>
                    </Stack>
                </Box>
                )}
            </Stack>
        </>
    );
};
